<template>
  <section class="projects-featured">
    <ProjectThumbnail
        v-if="loaded && !failed"
        v-for="(project, index) in projects"
        :key="project.id"
        :index="index"
        :id="project.id"
        :loaded="true"
        :title="project.name"
        :urlPostFix="project.urlPostFix"
        :thumbnails="project.thumbnail"/>
    <ProjectThumbnail
        v-if="!loaded && !failed"
        v-for="n in size"
        :key="n"
        :loaded="false"
        class="project-feature loading-element"/>
    <div
        v-if="failed"
        class="failed">
      Failed to load featured projects.
    </div>
  </section>
</template>

<script>
import API from '../class/API';
import ProjectThumbnail from '@/components/ProjectThumbnail';

export default {
  name: 'project-feature',
  components: { ProjectThumbnail },
  props: {
    size: {
      default: 2,
      type: Number
    }
  },
  data() {
    return {
      loaded: false,
      failed: false,
      projects: []
    };
  },
  mounted() {
    // Load the data
    API.request('GET', `project/featured/${this.$props.size}`, [], true).send()
        .then((data) => {
          this.$data.projects = data;
          this.$data.loaded = true;
        })
        .catch(() => {
          this.$data.failed = true;
        });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ProjectsFeatured.vue